import { ArrowRight, CheckCircle2, LockKeyhole, Map, ShieldCheck, Sparkles } from 'lucide-react';
import type { Meta } from '../types';

type Props = { meta: Meta | null; busy: boolean; onDevLogin: () => void };

export function Landing({ meta, busy, onDevLogin }: Props) {
  return (
    <main className="landing-shell">
      <nav className="landing-nav">
        <a className="brand" href="/"><span className="brand-mark">ㅎ</span><span>한반도 컬렉션</span></a>
        <a className="button button-ghost" href="/api/auth/google/start">Google로 시작하기 <ArrowRight size={16} /></a>
      </nav>
      <section className="landing-hero">
        <div className="hero-copy">
          <span className="eyebrow"><Sparkles size={14} /> 나의 대한민국 여행 아카이브</span>
          <h1>다녀온 곳은 색으로,<br />기억은 기록으로.</h1>
          <p>전국 17개 지역의 관광지와 맛집을 수집하고, 다음 여행을 계획하세요. 내 기록은 나만 보고, 공개하고 싶은 순간만 골라 나눌 수 있습니다.</p>
          <div className="hero-actions">
            <a className="button button-primary button-large" href="/api/auth/google/start">Google로 무료 시작 <ArrowRight size={18} /></a>
            {meta?.devAuthEnabled && <button className="button button-secondary button-large" type="button" disabled={busy} onClick={onDevLogin}>{busy ? '준비 중…' : '로컬 데모 열기'}</button>}
          </div>
          <div className="hero-trust"><LockKeyhole size={16} /> 모든 기록은 계정별로 분리되며, 비공개 메모는 공유 화면에 노출되지 않습니다.</div>
        </div>
        <div className="hero-visual" aria-label="여행 컬렉션 화면 미리보기">
          <div className="hero-orbit orbit-one" /><div className="hero-orbit orbit-two" />
          <div className="preview-card preview-main">
            <div className="preview-top"><span>나의 전국 여행지도</span><strong>47%</strong></div>
            <div className="preview-map">
              <div className="mini-korea">
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((cell) => <i key={cell} className={`cell-${cell % 5}`} />)}
              </div>
              <div className="preview-stats"><b>8</b><span>방문 지역</span><b>36</b><span>수집한 장소</span><b>4</b><span>다음 여행 후보</span></div>
            </div>
          </div>
          <div className="preview-card preview-memory"><span>TRAVEL NOTE</span><b>제주 · 성산일출봉</b><p>새벽 바람까지 오래 기억하고 싶은 곳</p><small>2026. 05 · ★ 5.0</small></div>
          <div className="preview-card preview-badge"><span>LEVEL 3</span><b>전국 탐험가</b><small>다음 레벨까지 3개 지역</small></div>
        </div>
      </section>
      <section className="landing-features">
        <article><span><Map /></span><h2>지도 위에 쌓이는 기록</h2><p>미방문부터 재방문 희망까지 다섯 가지 상태로 전국을 한눈에 봅니다.</p></article>
        <article><span><CheckCircle2 /></span><h2>지역마다 10개의 시작점</h2><p>대표 관광지 5곳과 음식문화 장소 5곳을 체크하고 나만의 장소도 더합니다.</p></article>
        <article><span><ShieldCheck /></span><h2>나만 보는 안전한 기록</h2><p>계정별로 데이터를 분리하고, 비공개 메모는 공개 프로필에서 완전히 제외합니다.</p></article>
      </section>
    </main>
  );
}
